module.exports = __webpack_public_path__ + "img/company_placeholder.7e66aff7.png";